import axios, { AxiosError } from "axios"
import {
  requestInterceptorErrorSecurityCredentials,
  requestInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
  responseInterceptorSuccessCredentials,
} from "interceptors"
import { CLIENT_RETENTION_PATH, NOTIFY_PATH } from "../../constants/paths"

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
)

export const notificationClientRetentionService = async (
  mails: string,
  serialInvoice: string,
  customerName: string,
  documentId: number,
  userId: number | null,
) => {
  try {
    const result = await instance.get(NOTIFY_PATH + CLIENT_RETENTION_PATH, {
      params: { mails, serialInvoice, customerName, documentId, userId },
    })
    return result
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
